/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
export type CartCustomHold_item$ref = any;
export type CartCustomHold_item = {
    readonly holds: ReadonlyArray<{
        readonly expirationDate: string | null;
    } | null> | null;
    readonly " $refType": CartCustomHold_item$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "CartCustomHold_item",
    "type": "Item",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "LinkedField",
            "alias": null,
            "name": "holds",
            "storageKey": null,
            "args": null,
            "concreteType": "Hold",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "expirationDate",
                    "args": null,
                    "storageKey": null
                }
            ]
        }
    ]
} as any);
(node as any).hash = 'ccd12f1794d78b73ae758abc606369f0';
export default node;
